var app = app ||  {};
app.ajaxrequest = app.ajaxrequest || {};

;(function(namespace, $){

  var ajaxRequest = function() {


    function initialize(uri, method, datatype, data, callback) {

      var callbacks = $.Callbacks();
      callbacks.add(callback);

      $.ajax({
        url: url + uri,
        type: method,
        headers: { 'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
        dataType: datatype,
        data: data,
      })
      .done(function(data) {
        callbacks.fire(data);
      })
      .fail(function(data) {
        console.log("error");
      })
    }
    namespace.initialize = initialize;
  };

  var main = new ajaxRequest();

})(app.ajaxrequest, jQuery);


